import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
  Type,
  ViewChild,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort, MatSortable } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { merge } from "rxjs";
import { startWith } from "rxjs/operators";
import { MyUtils } from "src/app/services/my-utils.service";
import { ICol } from "../../models/columns/i-col";
import { ICellComponent } from "../../models/i-cell-component";
import { TableAction } from "../../models/table-action";
import { TableStructure } from "../../models/table-structure";
import { RecordsManager } from "../../records-manager";

@Component({
  selector: "smart-table",
  templateUrl: "./smart-table.component.html",
  styleUrls: ["./smart-table.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmartTableComponent<T extends object> implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator!: MatPaginator;

  dataSource!: MatTableDataSource<T>;

  private cols!: ICol<T, Type<ICellComponent<T>>>[];
  actions!: TableAction<T>[];
  //displayedColumns!: (Extract<keyof T, string> | "actions")[];
  sizes!: number[];
  type!: "clientSide" | "serverSide";
  defaultSorting: MatSortable | undefined;

  actionColMinWidth!: string;
  disableSort!: boolean;

  constructor(
    public recordsManager: RecordsManager<T>,
    private cdr: ChangeDetectorRef,
    public utils: MyUtils
  ) {}

  ngOnInit(): void {
    this.dataSource = this.recordsManager.dataSource;
    this.setTableConfig(this.recordsManager.tableConfig);
    this.recordsManager.tableCdr = this.cdr;
  }

  ngAfterViewInit() {
    this.recordsManager.paginator = this.paginator;
    this.recordsManager.sort = this.sort;
    if (this.type === "clientSide") {
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      if (this.defaultSorting) {
        this.sort.sort(this.defaultSorting);
        this.cdr.detectChanges();
      }
    } else {
      if (this.defaultSorting) {
        this.sort.sort(this.defaultSorting);
        this.cdr.detectChanges();
      }
      this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
      //this.onLoad();
      this.recordsManager.initServerSideDataSubscription();
    }
  }

  ngOnDestroy() {
    //if (this.type === "serverSide") {
    this.recordsManager.unsubscribeFromDataSubscription();
    //}
  }

  setTableConfig(structure: TableStructure<T> | undefined) {
    //this.cols = structure.cols;
    //this.actions = structure.actions;
    //this.displayedColumns = this.cols.map((col) => col.columnDef);
    if (structure) {
      this.sizes = structure.pageSizes;
      this.type = structure.type;
      this.defaultSorting = structure.sortBy;
      this.disableSort = !structure.disableSort 
 
    }

    /* if (this.actions && this.actions.length > 0) {
      this.displayedColumns.push("actions");
      this.actionColMinWidth = this.actions.length * 50 + "px";
    } */
  }

  onActionClick(action: TableAction<T>, element: any) {
    action.command.execute(element);
  }

  onLoad() {
    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        startWith({})
        //switchMap(() => this.recordsManager.loadServerSideTableData())
      )
      .subscribe();
  }

  get filteredCols() {
    let f = this.recordsManager.tableConfig?.cols.filter((col) => col.visible);
    return f;
  }

  get displayedColumns() {
    return this.filteredCols?.map((col) => col.columnDef);
  }

  isLoading() {
    return this.recordsManager.isLoading;
  }
}
